module.exports = __webpack_public_path__ + "static/media/doa-cover.caf173f3.jpg";